import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from '../atoms/Button';
import Icon from '../atoms/Icon';
import clsx from 'clsx';
import styles from '../../styles/components/molecules/CtaBox.module.scss';

interface CtaBoxProps {
  className?: string;
  type: string;
  h2?: string;
  p?: any;
  href?: string;
  onClick?: () => void;
  label: string;
  icon?: string;
  slim?: boolean;
}

export default function CtaBox(props: CtaBoxProps) {
  const { h2, slim, href, p, onClick, icon, type, label, className } = props;
  const classes = clsx(styles.ctaBox, { [styles.slim]: slim }, className);

  return (
    <div className={classes}>
      <Icon name={type} />
      {!!(h2 || p) && (
        <div>
          {!!h2 && <h2>{h2}</h2>}
          {!!p && <p>{p}</p>}
        </div>
      )}
      <Button
        large
        dark
        icon={icon || type}
        label={label}
        onClick={onClick}
        href={href}
      />
    </div>
  );
}
